import { createContext, use, type ReactNode } from 'react';

export interface SectionListContextModel {
	canEdit: boolean;
}

const SectionListContext = createContext<SectionListContextModel | null>(null);

export function SectionListContextProvider({ canEdit, children }: { canEdit: boolean; children: ReactNode }) {
	return <SectionListContext value={{ canEdit }}>{children}</SectionListContext>;
}

export function useSectionList() {
	const context = use(SectionListContext);
	if (!context) {
		throw new Error('useSectionList must be used within a SectionListContextProvider');
	}
	return context;
}
